<template>
  <div class="row">
    <div class="col-6">
      <div class="pt-2 pb-2 bg-gray-500 text-center">
        <h6 class="m-0">GROUPS</h6>
      </div>
      <div class="pt-2 px-2 border border-gray-200" style="height: 55vh">
        <group-list-wrapper :indexUrl="indexUrl"></group-list-wrapper>
      </div>
    </div>
    <div class="col-6">
      <div class="pt-2 pb-2 bg-gray-500 text-center">
        <h6 class="m-0">USER PERMISSIONS</h6>
      </div>
      <div class="pt-2 px-2 border border-gray-200" style="height: 55vh">
        <permission-list-wrapper></permission-list-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import GroupListWrapper from './group-list-wrapper';
import PermissionListWrapper from './permission-list-wrapper';

export default {
  components: {
    GroupListWrapper,
    PermissionListWrapper,
  },

  props: {
    indexUrl: String,
  },
}
</script>
